module.exports = __webpack_public_path__ + "img/nature-16.8e2d3ce3.jpg";